module.exports = __webpack_public_path__ + "assets/add-sticker_icon.7b8e3811.svg";